import React, { type FC } from 'react'

import {
    type CybusDetailedEndpoint,
    selectDetailedEndpoint,
    selectDisabableLoadedDetailedEndpoint,
    selectEnabableLoadedDetailedEndpoint,
    selectLoadedDetailedEndpoint,
    Translation,
} from '../../../../domain'

import { ResourceDetails, type ResourceDetailsModalsProps } from '../../Resources'
import { DeleteModal, DisableModal, EnableModal } from '../Bulk'
import { Content } from './Content'
import { HeaderActions } from './HeaderActions'
import { HeaderDetails } from './HeaderDetails'

const Modals: FC<ResourceDetailsModalsProps> = ({ leave }) => {
    return (
        <>
            <EnableModal endpointsSelector={selectEnabableLoadedDetailedEndpoint} />
            <DisableModal endpointsSelector={selectDisabableLoadedDetailedEndpoint} />
            <DeleteModal endpointsSelector={selectLoadedDetailedEndpoint} onConfirmed={leave} />
        </>
    )
}

export const Details: FC = () => (
    <ResourceDetails<CybusDetailedEndpoint>
        subscriptionUsecase="manageEndpointUsecase"
        resourceSelector={selectDetailedEndpoint}
        notFoundTitle={Translation.ENDPOINT_NOT_FOUND}
        modals={Modals}
        content={Content}
        headerResourceName={Translation.ENDPOINT}
        headerName="name"
        headerActions={HeaderActions}
        infoTitle={Translation.ENDPOINT_DETAILS_DOCUMENTATION_TITLE}
        infoBody={Translation.ENDPOINT_DETAILS_DOCUMENTATION_BODY}
        headerDetails={HeaderDetails}
    />
)
